<template>
  <empty-state class="margin-auto mt-12">
    <template #icon>
      <v-icon size="80" color="error" icon="$warning" />
    </template>
    <template #description>
      <span>{{ $t("cloudBackupAndRestore.error.title") }}</span>
    </template>
    <template #button>
      <v-btn
        color="primary"
        data-testid="backup-and-restore-retry-btn"
        rounded
        size="large"
        @click="$emit('retry')"
      >
        {{ $t("cloudBackupAndRestore.error.tryAgain") }}
      </v-btn>
    </template>
  </empty-state>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import EmptyState from "@/components/EmptyState.vue";

export default defineComponent({
  components: {
    EmptyState,
  },
  emits: ["retry"],
});
</script>

<style lang="scss" scoped></style>
